<template lang="html">
  <div
    :class="['btn-custom-block', `btn-style_${$props.type}`]"
    :style="containerStyle"
  >
    <button
      v-if="$props.tag === 'button'"
      class="btn"
      @click.prevent.stop="click()"
    >
      <slot />
    </button>
    <a
      v-if="$props.tag === 'a'"
      class="btn"
      @click.prevent="clickButton($props.href)"
      :href="'#'"
    >
      <slot />
    </a>
  </div>
</template>

<script lang="js">
  const QUICK_START = `${process.env.VUE_APP_BASE_API_URL}api/quickstart_auth?source=landing`;

  import GetId from '../../modules/mixins/GetId';

  export default {
  name: 'SrcBaseComponentsUiButton',
  props: {
    ga: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: '45px',
    },
    tag: {
      type: String,
      default: 'button',
    },
    href: {
      type: String,
      default: '#',
    },
  },
  mixins: [
    GetId,
  ],
  data() {
    return {
      quick_start_target: QUICK_START,
    };
  },
  computed: {
    containerStyle() {
      return `height: ${this.$props.height}; max-height: ${this.$props.height};`;
    },
  },
  mounted() {},
  methods: {
    async clickButton(link) {
      if(this.$props.ga === 'buttonPlay'){
        gtag('event', 'click', { 'event_category': 'landing_tutorial',  'event_label': 'play_btn' }); // eslint-disable-line no-undef
        try {
          await fetch(new Request(
              `${this.$mainUrl}api/funnel_01/020/${this.getId()}`,
              {
                method: 'GET',
                mode: 'no-cors',
              })
          );
        } finally {

          window.location.href = `${this.$mainUrl}${this.$utmTags}`;
        }

      } else {
        window.location.replace(link);
      }
    },
    async click() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss">
@import "../../../static/scss/_mixins";
.btn-custom-block {
  padding: 2px;
  margin-right: 2px;
  display: flex;

  .btn {
    @include site-font(default, 15px, 500);
    @include basic-flex(row, center, center);
    line-height: 1.2rem;
    height: 100%;
    width: 100%;
    min-width: 0px;
    border: 2px solid #242333;
    background-image: linear-gradient(90deg, #242333, #3c3b53);
    position: relative;
    padding: 0px 50px;

    &:hover:not(:active) {
      background-image: linear-gradient(90deg, #242333, #6f6d99);
    }

    &:active:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }

  &.btn-style_without-border {
    margin-right: 0;
    padding: 0;
    &.orange {
      &:hover,
      &:focus {
        .btn {
          background: {
            image: linear-gradient(90deg, lighten(#F52CBF, 5%) 0%, lighten(#FF7C46, 5%) 100%);
          }
        }
      }
      .btn {
        background: {
          image: linear-gradient(90deg, #F52CBF 0%, #FF7C46 100%);
        }
      }
    }
    .btn {
      border: none;
    }
  }

  &.btn-style_primary {
    .btn {
      &:active:before {
        background: linear-gradient(90deg, unquote('rgba(#f52bc0, .25)') 0%,
        unquote('rgba(#ffffff, 0)')25%, unquote('rgba(#ffffff, 0)') 75%, unquote('rgba(#ff7c45, .25)') 100%);
      }
    }
  }

  &.btn-style_primary-two {
    .btn {
      &:active:before {
        background: linear-gradient(90deg, unquote('rgba(#6808c2, .25)') 0%,
        unquote('rgba(#ffffff, 0)') 25%, unquote('rgba(#ffffff, 0)') 75%, unquote('rgba(#f52bc0, .25)') 100%);
      }
    }
  }

  &.btn-style_secondary {
    .btn {
      &:active:before {
        background: linear-gradient(90deg, unquote('rgba(#5d588a, .25)') 0%,
        unquote('rgba(#ffffff, 0)') 25%, unquote('rgba(#ffffff, 0)') 75%, unquote('rgba(#8e87c4, .25)') 100%) !important;
      }
    }
  }

  &.btn-style_third {
    background-image: linear-gradient(90deg, #FF905A, #D94FC7);
    border: none;
    &:active,
    &:hover {
      background-image: linear-gradient(90deg, rgb(255, 134, 74), rgb(226, 65, 205));
    }
    .btn {
      background: transparent;
      border: none;
      text-shadow: 0 3px 3px rgba(#090a0f, 0.5);
      &:active,
      &:hover {
        background: transparent;
      }
    }
  }

  &.btn-style_secondary-green {
    background-image: linear-gradient(90deg, #3deb6e, #57b9c9);

    .btn:active {
      background-image: linear-gradient(90deg, #302f43, #43425d);
    }

    .btn {
      &:active:before {
        background: linear-gradient(
          90deg,
          rgba(#3deb6e, .25) 0%,
          rgba(#ffffff, 0) 25%,
          rgba(#ffffff, 0) 75%,
          rgba(#57b9c9, .25) 100%
        );
      }
    }
  }

  &.btn-style_secondary-yellow {
    background-image: linear-gradient(90deg, #EABE45, #cb4cbc);

    .btn:active {
      background-image: linear-gradient(90deg, #302f43, #43425d);
    }

    .btn {
      &:active:before {
        background: linear-gradient(
          90deg,
          rgba(#EABE45, .25) 0%,
          rgba(#ffffff, 0) 25%,
          rgba(#ffffff, 0) 75%,
          rgba(#cb4cbc, .25) 100%
        );
      }
    }
  }

  @for $i from 10 through 32 {
    &.fs-#{$i} {
      .btn {
        font-size: #{$i}px;
      }
    }
  }

  @for $i from 5 through 70 {
    @if $i % 5 == 0 {
      &.px-#{$i} {
        .btn {
          padding-left: #{$i}px !important;
          padding-right: #{$i}px !important;
        }
      }
    }
  }
  &.pl70 {
    .btn {
      padding-left: 70px !important;
    }
  }

  @for $i from 1 through 20 {
    &.custom-bg-#{$i} {
      @include position(relative);
      .btn {
        position: relative;
        text-transform: uppercase;
        &:after {
          content: '';
          display: block;
          @include position(absolute, 0, 0, 0, 0);
          background: {
            image: url("/assets/images/btn-bg/custom-bg-#{$i}.png");
            size: cover;
          }
        }
      }
    }
  }

  @for $i from 0 through 20 {
    &.mb-#{$i}-px {
      margin-bottom: #{$i}px;
    }
  }

  @for $i from 0 through 50 {
    &.mr-#{$i}-px {
      margin-right: #{$i}px;
    }
  }

  @for $i from 0 through 50 {
    &.ml-#{$i}-px {
      margin-left: #{$i}px;
    }
  }

  &.space-around {
    .btn {
      justify-content: space-around !important;
    }
  }

  &.space-evenly {
    .btn {
      justify-content: space-evenly !important;
    }
  }

  &.no-text-shadow {
    .btn {
      text-shadow: none !important;
    }
  }

  &.hovered-icon--white:hover {
    .btn {
      .button-icon {
        background: linear-gradient(270deg, #fff 0%, #fff 107.69%);
      }
    }
  }
}
</style>
